import { useFetchQuery, useMutate } from "../../utils/customHooks";
import { endpointUrl } from "../../utils/endpoints";
const Services = () => {
  const { data, isLoading, isError, isFetched, isRefetching, refetch } =
    useFetchQuery(endpointUrl.getServices, ["services"], {
      is_draft: false,
    });
  const handleRefetch = () => {
    refetch();
  };
  const onSuccess = (data: { message?: string }) => {
    // toast.success(data.message);
    // refetch();
    // setIsRefetching(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onError = (error: any) => {
    // toast.error(error.response?.data?.message || "Something went wrong");
  };

  const createServiceMutation = useMutate(endpointUrl.createMessage, "POST", {
    onError,
    onSuccess,
  });
  // const handleSubmit=()=>{
  //   createServiceMutation({  });
  // }
  console.log(data);
  return (
    <>
      <div>
        loading: {isLoading ? <span>Loading</span> : <span>loaded</span>}
      </div>
    </>
  );
};
export default Services;
